import React, { useState } from 'react';

export default function AssignModal({ orderId, subOrderId, designers, onAssign, onClose }) {
  const [selectedDesigner, setSelectedDesigner] = useState('');

  const handleConfirm = () => {
    if (!selectedDesigner) return;
    onAssign(orderId, subOrderId, Number(selectedDesigner));
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Assign Order</h3>
          <button className="modal-close" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20"><path d="M18 6L6 18M6 6l12 12" /></svg>
          </button>
        </div>
        <div className="modal-body">
          <p className="modal-subtitle">Assign order <strong>#{orderId}</strong> to a restoration team member</p>
          <div className="form-group">
            <label className="form-label">Select Designer / Manager</label>
            <select
              className="form-select"
              value={selectedDesigner}
              onChange={e => setSelectedDesigner(e.target.value)}
            >
              <option value="">-- Select Assignee --</option>
              <optgroup label="Managers">
                {designers.filter(d => d.groupId === 73).map(d => (
                  <option key={d.id} value={d.id}>{d.name}</option>
                ))}
              </optgroup>
              <optgroup label="Designers">
                {designers.filter(d => d.groupId === 64).map(d => (
                  <option key={d.id} value={d.id}>{d.name}</option>
                ))}
              </optgroup>
            </select>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={!selectedDesigner}
          >
            Confirm Assignment
          </button>
        </div>
      </div>
    </div>
  );
}
